import type { FC, ReactNode } from 'react'

import { TRUST_POINTS } from '@/constants/content'

export const TrustStrip: FC = (): ReactNode => {
    return (
        <section id='highlights' aria-label='ویژگی‌های محصولات خوزکیمیا زاگرس' className='relative z-10 px-5 sm:px-8'>
            <ul className='mx-auto -mt-16 grid max-w-6xl grid-cols-1 gap-px overflow-hidden rounded-[2rem] border border-sand bg-sand shadow-[0_30px_70px_-45px_rgba(15,42,30,0.65)] sm:grid-cols-2 lg:grid-cols-4'>
                {TRUST_POINTS.map(({ icon: Icon, title, text }) => (
                    <li key={title} className='flex items-start gap-4 bg-card p-6 lg:p-7'>
                        <span className='flex size-12 shrink-0 items-center justify-center rounded-2xl bg-forest-700 text-gold'>
                            <Icon aria-hidden='true' className='size-6' strokeWidth={1.6} />
                        </span>

                        <span className='flex flex-col'>
                            <span className='font-heading text-xl font-bold text-forest-900'>
                                {title}
                            </span>

                            <span className='mt-1 text-sm leading-6 text-muted-foreground'>
                                {text}
                            </span>
                        </span>
                    </li>
                ))}
            </ul>
        </section>
    )
}
